import React from 'react';

const PricingPage = () => (
    <>
        <h1>Pricing</h1>
        <p>Free for now.  </p>
    </>
);

export default PricingPage;